import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import BodyLoginUser from "./BodyLoginUser";
import Base from "../Base";

const LoginPage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / connexion / user"
        description="Connectez-vous pour enregistrer vos articles favories plus facilement"
      />
      <Base>
        <BodyLoginUser />
      </Base>
    </Fragment>
  );
};

export default LoginPage;
